/**
 * @param condition
    {
        "type": "language",
        "languages": ["en"]
    }
 */

ConditionalFilters.register("language", function (entity, condition) {
    console.log("conditionalFilter.language ", entity, condition)
    return condition.languages.includes(app.info.language)
})